export default __webpack_public_path__ + "static/media/CH.a58facc6.svg";